var jcsfApp;
(function (jcsfApp) {
    var app;
    (function (app) {
        var auth;
        (function (auth) {
            var AuthInterceptorService = (function () {
                function AuthInterceptorService($q, $location, $injector) {
                    var $this = this;
                    this.$q = $q;
                    this.$location = $location;
                    this.$injector = $injector;
                    this.responseError = function (rejection) {
                        if (rejection.status === 401) {
                            window.location.href = ('#/notAuthorized');
                        }
                        else if (rejection.status === 403) {
                            window.location.href = ('#/forbidden');
                        }
                        else if (rejection.status === 404) {
                            window.location.href = ('#/notFound');
                        }
                        else if (rejection.status === 500) {
                            window.location.href = ('#/serverError');
                        }
                        return $this.$q.reject(rejection);
                    };
                }
                AuthInterceptorService.prototype.request = function (config) {
                    config.headers = config.headers || {};
                    var authData = JSON.parse(window.localStorage.getItem('authenticationInfo'));
                    if (authData) {
                        var token = authData.token;
                        config.headers.Authorization = "Bearer " + token;
                    }
                    return config || this.$q.when(config);
                };
                AuthInterceptorService.prototype.response = function (response) {
                    return response || this.$q.when(response);
                };
                AuthInterceptorService.$inject = ['$q', '$location', '$injector'];
                return AuthInterceptorService;
            })();
            auth.AuthInterceptorService = AuthInterceptorService;
            angular.module("jcsfApp")
                .service("AuthInterceptorService", AuthInterceptorService);
        })(auth = app.auth || (app.auth = {}));
    })(app = jcsfApp.app || (jcsfApp.app = {}));
})(jcsfApp || (jcsfApp = {}));
